import React from 'react';
import { Button } from 'react-bootstrap';
import NotificationsAlert from '../../../services/NotificationsAlert';
import Conect from '../../../../Api/Conect';
import './BlockStyles.css';

const ModalSetBlock = ({ isOpen, onClose, token, id_user, blockCommand, getPositions }) => {

    const close = () => {
        onClose();
    };

    const sendingCommand = async () => {
        try {
            const response = await Conect.post(`/Y2FkYmxvY2s=${token}`, {
                id_user: Number(id_user),
                id_vehicle: blockCommand[1],
                command: blockCommand[0],
            });

            if (response.data.erro) {
                NotificationsAlert('warning', 'Atenção', response.data.msg);
                onClose();
            } else {
                onClose();
                NotificationsAlert('success', 'Sucesso', 'Comando cadastrado com sucesso!');
                getPositions(); // Atualiza as posições após o comando
            }
        } catch (err) {
            onClose();
            console.error('Erro ao enviar comando:', err);
            NotificationsAlert('error', 'Erro', 'Não foi possível enviar o comando.');
        }
    };

    const renderButton = (label, onClick, variant = 'primary', extraStyles = {}) => (
        <Button
            className="btns-block"
            variant={variant}
            style={{
                marginTop: '3%',
                width: '30%',
                borderRadius: '20px',
                ...extraStyles,
            }}
            onClick={onClick}
        >
            {label}
        </Button>
    );

    return (
        isOpen && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3>Deseja {blockCommand[0] === 'UNLOCK' ? 'desbloquear' : 'bloquear'} este veículo?</h3>
                    <div className="modal-actions">
                        {renderButton('Cancelar', close, 'secondary', {position: 'absolute', left: '15%' })}
                        {renderButton('Confirmar', sendingCommand, 'primary', { position: 'absolute', right: '15%' })}
                    </div>
                </div>
            </div>
        )
    );
};

export default ModalSetBlock;
